import styled from 'styled-components';

export const FooterStyles = styled.footer`
  padding: 6rem 0 3rem 0;
  text-align: center;
  background: var(--black-1);
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  position: relative;
  
  /* Creates a subtle glowing ambient edge at the top of the footer */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 60%;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(99, 102, 241, 0.5), transparent);
  }

  .footer__text {
    margin: 0 auto;
    margin-top: 2rem;
    max-width: 450px;
    color: var(--gray);
    line-height: 1.6;
  }
  .footer__menuList {
    margin-top: 3rem;
    li {
      display: inline-block;
      margin: 0 1.5rem;
      a {
        color: var(--white-1);
        font-size: 1.5rem;
        font-weight: 500;
        transition: color 0.3s ease;
        
        &:hover {
          color: var(--primary);
        }
      }
    }
  }
  .footer__socialList {
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
    li {
      display: inline-block;
      margin: 0 1rem;
      a {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        color: var(--gray);
        background: rgba(255, 255, 255, 0.03);
        border: 1px solid rgba(255, 255, 255, 0.05);
        font-size: 1.8rem;
        transition: all 0.3s ease;
      }
      :hover {
        a {
          color: var(--white);
          background: rgba(99, 102, 241, 0.2);
          border-color: rgba(99, 102, 241, 0.5);
          transform: translateY(-3px);
        }
      }
    }
  }
  .copyright {
    margin-top: 1rem;
    color: rgba(255, 255, 255, 0.4);
    font-size: 1.3rem;
  }
`;